import DriverTagsApi from "../../services/api/DriverTags";
import { getPath, getQueryParams } from "../../utils";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import qs from "qs";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("error in driver tags actions:", err);
}

export const setDriverTagsList = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_TAGS_LIST,
    payload,
  };
};

export const setActiveDriverTag = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_DRIVER_TAG,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_DRIVER_TAGS,
    payload,
  };
};

export const setCurrentPageDriverTags = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_DRIVER_TAGS,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_DRIVER_TAGS,
    payload,
  };
};

export const setDriverTagsMappingList = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_TAGS_MAPPING_LIST,
    payload,
  };
};

export const setActiveFiltersMappings = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_DRIVER_TAGS_MAPPINGS,
    payload,
  };
};

export const setCurrentPageDriverTagsMappings = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_DRIVER_TAGS_MAPPINGS,
    payload,
  };
};

export const getDriverTagsList =
  (filters = {}, pageRequest = {}, mappingFilters) =>
  async (dispatch) => {
    try {
      if (!pageRequest.page) {
        pageRequest.page = 1;
      }
      let newFilters = { ...filters };
      if (newFilters["type"]) {
        newFilters["types"] = [newFilters["type"]];
        delete newFilters["type"];
      }
      if (mappingFilters) {
        newFilters["types"] = mappingFilters;
      }
      let finalPayload = {
        ...pageRequest,
        ...newFilters,
      };
      const queryParamsString = qs.stringify(finalPayload, {
        addQueryPrefix: true,
        encode: false,
      });
      dispatch(setLoader(true));
      let response = await DriverTagsApi.getDriverTagsList(queryParamsString);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setDriverTagsList(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(setCurrentPageDriverTags(getPath(pageRequest, "page", 1)));
        }
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getDriverTagsMappingList =
  (filters = {}, pageRequest = {}, tag_type) =>
  async (dispatch) => {
    try {
      if (!pageRequest.page) {
        pageRequest.page = 1;
      }
      let newFilters = { ...filters };
      if (filters["target_date"]) {
        newFilters["target_date"] = filters["target_date"] + "T00:00:00Z";
      }
      if (newFilters["tag_types"] === undefined) {
        if (tag_type === "OTHER") {
          newFilters["tag_types"] = ["OTHER"];
        } else {
          newFilters["tag_types"] = [
            "ACCOUNTING",
            "ACCOUNTING_STRATEGY",
            "MING_TAG",
            "INCENTIVE",
          ];
        }
      } else {
        newFilters["tag_types"] = [newFilters["tag_types"]];
      }
      let finalPayload = {
        ...pageRequest,
        ...newFilters,
      };
      const queryParamsString = qs.stringify(finalPayload, {
        addQueryPrefix: true,
        encode: false,
      });
      dispatch(setLoader(true));
      let response = await DriverTagsApi.getDriverTagsMappingList(
        queryParamsString
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setDriverTagsMappingList(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(
            setCurrentPageDriverTagsMappings(getPath(pageRequest, "page", 1))
          );
        }
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFiltersMappings(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFiltersDriverTagsMappings" }));
        }
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getDriverTag = (id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverTagsApi.getDriverTag(id);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setActiveDriverTag(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const createDriverTag = (url, data) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverTagsApi.createDriverTag(url, data);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.CREATION_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateDriverTag = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverTagsApi.updateDriverTag(id, data);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
